import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

const WA = "https://wa.me/34663118471";

export const WhatsAppButton = () => (
  <motion.a
    href={WA}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    aria-label="Chat on WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.4, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.95 }}
    className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-[#052e16] pl-4 pr-5 py-3.5 rounded-full shadow-lg shadow-black/40 group"
  >
    <MessageCircle size={22} strokeWidth={2.4} className="shrink-0" />
    <span className="font-head uppercase tracking-wide text-sm hidden sm:inline">
      WhatsApp us
    </span>
    <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#ff3b30] rounded-full animate-ping" />
    <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#ff3b30] rounded-full" />
  </motion.a>
);
